import { Injectable } from '@angular/core';
import { DataStoreService } from 'src/app/features/fnol/services/data-store.service';
import { ClaimtypeBenefittypeAbstractService } from './claimtype-benefittype-abstract.service';
import { AxisInputNumberPipe } from 'axis-components';
import { FnolService } from 'src/app/features/fnol/services/fnol.service';
import { CacheService } from 'src/app/shared/services/cache.service';
@Injectable({
  providedIn: 'root'
})
export class ClaimTypeCommonService extends ClaimtypeBenefittypeAbstractService {
  
  constructor(public dataStoreService: DataStoreService, public axisPipe: AxisInputNumberPipe, public fnolService: FnolService, public cacheService: CacheService) {
    super(dataStoreService, axisPipe, fnolService, cacheService);
  }

  getClaimTypeData() {
    if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Travel') {
      return this.getTravelDetails(this.step2);
    }
    
    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Other') {
      return this.getOtherDetails();
    }

    else if (this.dataStoreService.get(this.step2).uiData['claimBenefits'] === 'Personal Accident') {
      return this.personalAccidentPayload();
    }
  }
}